@if (me && shouldShowHeader) {
  <div class="header" [style]="{ background: getCompanyColor(me.companyId) }">
    <div class="w-full flex items-center justify-center">
      <div class="flex flex-col items-center justify-center text-white font-medium gap-1">
        <span>{{ 'pre-employment-activities.header.title' | translate }}</span>
        <span>{{ 'pre-employment-activities.header.subtitle' | translate }}</span>
      </div>
      <p-button
        class="absolute right-10 text-white"
        [style]="{ background: getCompanyColor(me.companyId) }"
        severity="secondary"
        [rounded]="true"
        [text]="true"
        (onClick)="logout()"
      >
        <i class="pi pi-sign-out topbar-action-icon text-white"></i>
      </p-button>
    </div>
  </div>
  <div class="w-full flex items-center justify-center pt-4 mt-24">
    <div class="flex items-center justify-center flex-col px-8 md:px-0">
      <h3 class="w-full mr-auto">
        Ciao <span class="inline-block lowercase first-letter:uppercase">{{ me.firstName }}</span
        >,
      </h3>
      <p class="w-full items-start font-semibold">
        {{ 'pre-employment-activities.description' | translate }}
      </p>
    </div>
  </div>
}
<div class="md:max-w-3xl mx-auto mt-4 w-full px-8 md:px-0">
  <app-pre-employment-list-activities
    [activities]="listActivities?.items ?? []"
    [hiredAt]="me?.hiredAt ?? null"
    (activityClick)="onClickActivity($event)"
  >
  </app-pre-employment-list-activities>
</div>

<app-pre-employment-selfservice-dialog
  *ngIf="openSelfserviceDialog"
  [open]="openSelfserviceDialog"
  [activity]="selectedActivity"
  [selfServiceType]="selfServiceType"
  [me]="me"
  (submitted)="loadActivities()"
  [requestId]="selectedActivity?.id"
  (close)="onCloseDialog()"
></app-pre-employment-selfservice-dialog>

<app-pre-employment-acknowledgement-dialog
  *ngIf="openInspectionDialog"
  [open]="openInspectionDialog"
  [activity]="selectedActivity"
  [me]="me"
  (submitted)="loadActivities()"
  [requestId]="selectedActivity?.id"
  (close)="onCloseDialog()"
></app-pre-employment-acknowledgement-dialog>

<app-pre-employment-file-upload-dialog
  *ngIf="openUploadFileDialog"
  [open]="openUploadFileDialog"
  [me]="me"
  [activity]="selectedActivity"
  (close)="onCloseDialog()"
  (submitted)="loadActivities()"
  [requestId]="selectedActivity?.id"
></app-pre-employment-file-upload-dialog>
@if (shouldShowHeader) {
  <p-toast [baseZIndex]="10001"></p-toast>
}
